import { render, staticRenderFns } from "./ReleaseNote.vue?vue&type=template&id=e58de51e&scoped=true"
import script from "./ReleaseNote.vue?vue&type=script&lang=js"
export * from "./ReleaseNote.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNote.vue?vue&type=style&index=0&id=e58de51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58de51e",
  null
  
)

export default component.exports